import React,{useState, useEffect} from "react";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import { NavLink } from "react-router-dom";

function Searchnav({imagesObj}) {

  return (
    <>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div class="searchnav-box">
              <img
                src={imagesObj?.img1}
                class="acc-logo"
                alt="logo"
              />
              <p class="desktop-tag">
                <span>Learning & Talent Transformation</span> <br />{" "}
                <p className="desktop-tag-1">VodafoneThree Talent Academy</p>
              </p>
              <p class="mobile-tag">
                <span>L&TT</span> <br /> <p className="mobile-tag-1">VodafoneThree</p>
              </p>
              {/* <NavLink to="/home"><img src="images/Home/home-icon-purple.png" class="home-icon" alt="homeicon" /></NavLink> */}
            </div>
          </div>
          <div class="searchnav-row">
            <div
              class="searchnav-box"
              style={{ textAlign: "right", marginTop: "10px" }}
            >
              {/* <p>Hello {localStorage.getItem("empName")}!</p> */}
              {/* <p>Hello !</p> */}
              <WelcomeName/>
              <img src="/images/Avatar.png" class="user-img" alt="user-image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
